import useMedia from './use-media.esm.js';
import { useSafeThemeUI } from '../theme-provider/use-theme-ui.esm.js';
import { defaultBreakpoints } from '../themes/theme-keys/breakpoints.esm.js';
import { memoizedGet } from '../utils/object.esm.js';

var useTrueAtMediaBreakpointLessThen = function useTrueAtMediaBreakpointLessThen(breakpoint) {
  var theme = useSafeThemeUI();
  var breakpoints = memoizedGet(theme, 'breakpoints', defaultBreakpoints);
  var mediaBreakpoint = "screen and (max-width: ".concat(breakpoints.getValueAndUnit(breakpoint), ")");
  return useMedia([mediaBreakpoint], [true], false);
};

export default useTrueAtMediaBreakpointLessThen;
//# sourceMappingURL=use-true-at-media-breakpoint-less-then.esm.js.map
